import React from 'react'
import { t } from 'ttag'
import { Button } from 'react-bootstrap'

import { editJournalEntry } from '../../actions/journals'
import Form from '../form/Form'
import Field from '../form/Field'
import ActionButton from '../ActionButton'

const JournalInlineEdit = ({
  isEditing,
  entryEditRequest,
  dispatch,
  cancelEdit,
  selectedJournalEntry
}) => {
  const htmlToOutput = () => {
    if (isEditing) {
      return (
        <Form
          model="journals.entryForm"
          onSubmit={form => dispatch(editJournalEntry(selectedJournalEntry, form))}>
          {form => (
            <div>
              <Field
                model="journals.entryForm.entry"
                form={form}
                type="tinymce"
                label={t`Edit your entry`}
                required={true}
              />
              <div style={{ margin: '20px 0' }}>
                <ActionButton
                  request={entryEditRequest}
                  success={null}
                  type="submit"
                  className="btn btn-success small">
                  {' '}
                  {t`Update Journal Entry`}{' '}
                </ActionButton>
                <Button
                  style={{ marginLeft: '0.5em' }}
                  onClick={cancelEdit}
                  bsStyle="danger"
                  className="small">
                  {t`Cancel`}
                </Button>
              </div>
            </div>
          )}
        </Form>
      )
    }

    return <span dangerouslySetInnerHTML={{ __html: selectedJournalEntry.entry }}></span>
  }

  return htmlToOutput()
}

export default JournalInlineEdit
